export default __webpack_public_path__ + "static/media/filter.672bc3e6.svg";